import React, {useState, useEffect} from 'react';
import {t, getLanguage} from 'react-switch-lang';
import {getAllUsers} from '../../services/reports/kriReport';
import FormatList from './reportForm/components/format/FormatList';
import DownloadBtn from './reportForm/components/downloadBtn/DownloadBtn';
import SelectList from '../../components/FormFields/Select';
import * as yup from 'yup';
import {useForm, FormProvider} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';
import InputDate from '../../components/FormFields/inputDate/InputDate';
import {format} from 'date-fns';
import './Report.scss';

const ReportLog = () => {
  const isValidType = '';
  const lang = getLanguage();
  const [selectedFormat, setSelectedFormat] = useState();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [users, setUsers] = useState([]);
  const [format2, setFormat2] = useState('');

  const fetchUsers = async () => {
    try {
      const {data} = await getAllUsers();
      setUsers(data);
      return data;
    } catch (e) {}
  };

  useEffect(() => {
    fetchUsers().then((r) => {
      let users = [];
      r.forEach((item) => {
        users.push({
          value: item.id,
          label: item.firstName + ' ' + item.lastName,
        });
      });

      setUsers(users);
    });
  }, []);

  const schema = yup.object().shape({
    department: yup.object().nullable().required(t('message.fieldRequired')),
  });

  const methods = useForm({
    resolver: yupResolver(schema),
  });

  const {watch} = methods;
  let validFrom = watch('startDate');
  let validTo = watch('endDate');

  useEffect(() => {
    setSelectedFormat();
    setIsSubmitted(false);
  }, []);

  return (
    <div className="reports-page content">
      <FormProvider {...methods}>
        <div className="report-form-container">
          <div className="row  ml-0 mr-0">
            <div className="form-group pr-5">
              <label className="label" htmlFor="startDate">
                {t('reports.dateFrom')}
              </label>
              <InputDate
                name="startDate"
                maxDate={validTo}
                defaultValue={
                  new Date(new Date().getFullYear(), new Date().getMonth(), 1)
                }
                className={`date-height form-control ${
                  validTo === null && isSubmitted === true ? `error-field` : ''
                }`}
                isClearable={false}
                placeholderText={t('reports.dateFrom')}
              />
              {validFrom === null && isSubmitted === true ? (
                <span className="error-message position-absolute">
                  {t('message.fieldRequired')}
                </span>
              ) : (
                ''
              )}
            </div>
            <div className="form-group pr-5">
              <label className="label" htmlFor="endDate">
                {t('reports.dateTo')}
              </label>
              <InputDate
                name="endDate"
                minDate={validFrom}
                defaultValue={new Date()}
                className={`date-height form-control ${
                  validTo === null && isSubmitted === true ? `error-field` : ''
                }`}
                isClearable={false}
                placeholderText={t('reports.dateTo')}
              />
              {validTo === null && isSubmitted === true ? (
                <span className="error-message position-absolute">
                  {t('message.fieldRequired')}
                </span>
              ) : (
                ''
              )}
            </div>

            <div className="form-group pr-5">
              <label className="label w-100" htmlFor="department">
                {t('reports.user')}
                <span className="optional register line-height">
                  {t('common.optional')}
                </span>
              </label>
              <SelectList
                name="user"
                options={users}
                placeholder={t('common.select')}
                defaultValue=""
              />
            </div>
            <FormatList
              isValidType={isValidType}
              value={['PDF', 'XLSX']}
              parameterName="format"
              onChange={(e) => setFormat2(e)}
              isSubmitted={isSubmitted}
              setIsSubmitted={() => setIsSubmitted(false)}
              setSelectedFormat={(e) => setSelectedFormat(e.toLowerCase())}
              error={!format2.length > 0}
            />
            <DownloadBtn
              api={'reports/risks/report-log'}
              paramsLength={4}
              setIsSubmitted={(e) => setIsSubmitted(e)}
              apiParameters={{
                startDate:
                  validFrom !== null && validFrom !== undefined
                    ? `startDate=${encodeURIComponent(
                        format(validFrom, 'yyyy-MM-dd')
                      )}`
                    : '',
                endDate:
                  validTo !== null && validTo !== undefined
                    ? `endDate=${encodeURIComponent(
                        format(validTo, 'yyyy-MM-dd')
                      )}`
                    : '',
                user:
                  watch('user') !== null &&
                  watch('user') !== undefined &&
                  watch('user').value !== undefined
                    ? `user=${watch('user').value}`
                    : `user=`,
                format: format2,
              }}
            />
          </div>
        </div>
      </FormProvider>
    </div>
  );
};

export default ReportLog;
